// tslint:disable:object-literal-key-quotes
export const enCA = {
    'product-name': 'Prism',
    'actions': {
        'close': 'Close',
        'create-account': 'Create account',
        'account': 'Account',
        'continue': 'Continue',
        'login': 'Connect',
        'logout': 'Log out',
        'save': 'Save',
        'send': 'Send',
        'delete': 'Delete',
        'cancel': 'Cancel',
        'apply': 'Apply',
        'on': 'Enabled',
        'upload': 'Upload',
        'off': 'Disabled',
        'add': 'Add',
        'validation': 'Validation'
    },
    'time': {
        'is24': false,
        'last-modified': 'Last modified',
        'created': 'Created'
    },
    'errors': {
        'unknown': 'An error occured.',
        'wrong-username-or-password': 'Invalid username or password.',
        'email-not-verified': 'Please confirm your email address.',
        'email-already-in-use': 'This email address is already linked to another account.',
        'requires-recent-login': 'This operation requires a recent login.',
        'expired-or-invalid-action-code': 'The link your used is either invalid or expired.',
        'invalid-pin': 'The pin you entered is either invalid or expired.',
        'unable-to-link-device': 'We were unable to link the device to your account.',
        'unable-to-name-device': 'An error occured while naming this device.',
        'insufficient-rights': 'You do not have the rights to access this page.',
        'object-not-found': 'Unable to find what you are trying to access.',
        'invalid-data': 'The data you are trying to access is invalid.',
        'saving-error': 'An error occured while saving.',
        'delete-error': 'An error occured while deleting.',
        'required-field': 'This field is required.',
        'require-valid-email': 'Please enter a valid email',
        'enter-a-pin-first': 'Please enter a pin first.',
        'weak-password': 'This password is too weak.',
        'invalid-date': 'Please enter a valid date.',
        'name-required': 'You must specify the presentation\'s name.'
    },
    'services': {
        'auth-service': {
            'wrong-username-or-password': 'Invalid username or password.',
            'email-not-verified': 'Please confirm your email address.'
        }
    },
    'components': {
        modal: {
            'auth-modal': {
                'requires-recent-login': 'Please enter your password.'
            }
        },
        common: {
            'megabytes': 'MB',
            'delete-confirm': 'Are you sure you want to delete this item?',
            'file-selector': {
                'max-file-size': 'Max. file size',
                'accepted-files-types': 'Accepted files types',
                'select-file': 'Please, select a file',
                'drop-file': 'Drop the file.'
            },
            'json-editor': {
                'save-changes': 'Save changes',
                'invalid-json': 'The specified json is invalid.'
            }
        },
        guards: {
            'pending-changes': {
                title: 'Unsaved changes',
                subtitle: 'If you leave now, all unsaved changed will be lost.',
                content: 'Do you really want to leave and lose all your changes?',
                primaryAction: 'Stay',
                secondaryAction: 'Leave'
            }
        }
    },
    'modules': {
        'layouts': {
            navigation: {
                'developer-tools': 'Developer tools',
                'options': 'Options',
                'devices': 'Devices',
                'presentations': 'Presentations',
                'home': 'Home',
                'configurations': 'Configurations'
            }
        },
        'editors': {
            'speed-option': {
                'Slow': 'Slow',
                'Normal': 'Normal',
                'Fast': 'Fast'
            },
            nothing: {
                name: 'Nothing',
                description: 'This section will display nothing.'
            },
            unsupported: {
                'name': 'Not supported',
                'title': 'This section contains unsupported content',
                'description': 'This section contains content that is not supported anymore. You can copy it\'s content for backup.',
                'validation-error': 'You must change the section that is not supported anymore.'
            },
            header: {
                name: 'Header'
            },
            weather: {
                'name': 'Weather',
                'units': 'Units',
                'cities': 'Cities',
                'celcius': 'Celcius',
                'fahrenheit': 'Fahrenheit',
                'no-cities-match': 'There were no matches',
                'no-cities-error': 'You must select at least one city',
                'invalid-units-error': 'You must either select celcius or fahrenheit.',
                'enter-a-city-name': 'Enter the name of a city',
                'weather-speed': 'Transition speed',
                'invalid-speed-error': 'You must select a valid transition speed.'
            },
            news: {
                'name': 'News feed',
                'badwords-default1': '<First badword>',
                'badwords-default2': '<Second badword>',
                'and-so-on': '<...>',
                'sources-default1': '<Enter first rss url here.>',
                'sources-default2': '<Enter second rss url here.>',
                'logo-url-default': '<Enter logo\'s url here.>',
                'title-default': '<Enter the title of your news here.>',
                'content-default': '<The content of your new.>'
            },
            video: {
                'name': 'Video',
                'current-video': 'Current video',
                'replace-video': 'Upload new video',
                'aspect-ratio': 'Video aspect ratio',
                'Restrict': 'Fit',
                'Full': 'Zoom',
                'video-required': 'You must upload a video'
            },
            webpage: {
                'name': 'Web page',
                'url': 'Page address',
                'url-placeholder': 'Enter the full web page address',
                'pending': 'Validation in progress',
                'valid': 'The provided webpage address is valid and will be shown.',
                'invalid-url': 'The address you entered isn\'t a valid url.',
                'website-prevent-embedding': 'The webpage provider prevent us from embedding it\'s website.',
                'not-found': 'The webpage couldn\'t be found.',
                'unauthorized': 'You must authenticate to show this webpage. Contact the webpage owner to know how to connect and show this page.',
                'forbidden': 'You don\'t have the permissions to show this webpage. Contact the webpage owner to know how to connect and show this page.',
                'unknown': 'An unknown error occured. Please contact technical support for this error persist.'
            },
            slideshow: {
                'name': 'Edit Slideshow',
                'transition': 'Transition Animation',
                'slideshow-speed': 'Slideshow Speed',
                'display-mode': 'Display Mode',
                'transition-option': {
                    'NoAnimation': 'No animation',
                    'FadeInFadeOut': 'Fade in fade out'
                },
                'display-mode-option': {
                    'Restrict': 'Fit',
                    'Fill': 'Zoom',
                    'Blur': 'Fit with blurry background'
                },
                'images-table': {
                    'title': 'Pictures',
                    'no-images': 'No picture uploaded.',
                    'name': 'Name',
                    'order': 'Order',
                    'action': 'Action',
                    'add': 'Add picture'
                },
                'delete-comfirm': 'Are you sure you want to remove this picture from the slideshow?',
                'no-image-error': 'Slideshow must have at least one picture.',
                'no-transition-speed-error': 'Slideshow must have a valid transition speed.',
                'no-animation-error': 'Slideshow must have a valid transition animation.',
                'no-display-mode-error': 'Slideshow must have a valid display mode.'
            }
        },
        'super-admin': {
            configurations: {
                'configurations': 'Configurations',
                'client-configurations': 'Client configurations',
                'video': 'Video',
                'saving-success': 'The configuration was successfully saved',
                'saving-error': 'There was an error while saving.',
                'cant-load': 'Unable to get configuration file.',
                'video-success': 'The video was successfully updated.',
                'video-error': 'There was an error while uploading the video',
                'file-exceeds-maximum-size': 'The file exceeds the maximum size.',
                'file-type-invalid': 'The file type is invalid.',
                'unknown-device': 'Sorry, this device doesn\'t exist.'
            }
        },
        'presentations': {
            list: {
                'title': 'Your presentations',
                'create-presentation': 'Create new presentation',
                'failed-to-retrieve-list': 'There was an error while retrieving your presentations.',
                'failed-to-display-list': 'There was an error while trying to display your presentations',
                'jumbotron-empty-presentation-list': {
                    'title': 'Create your first presentation',
                    'current-page-details': 'You are currently on the presentation list page. Here, you can view and manage all the presentations you created.',
                    'instructions': 'A presentation is required to configure the visual shown on your device\'s screen. To create your first presentation, press the button below.'
                },
                'missing-description': 'Description unavailable.',
                'missing-name': 'Name Unavailable',
                'missing-date': 'Date unavailable'
            },
            edit: {
                'title': 'Edit presentation',
                'error-getting-presentation': 'An error occured while retrieving the presentation.',
                'invalid-theme-error': 'Please enter a valid theme.',
                'last-modified': 'Last modified',
                'video': 'Video',
                'new-presentation-default-name': 'Presentation Name',
                'new-presentation-default-description': 'Presentation description',
                'saving-success': 'The presentation was successfully saved.',
                'delete-success': 'Presentation has been deleted.',
                'delete-confirm': 'Are you sure you want to delete this presentation?',
                'invalid-json': 'Invalid JSON.',
                'select-section': 'Select a section of your presentation to configure it.',
                'name-is-required': 'Name is required.',
                'file-upload-ongoing': 'Uploading your file(s)...',
                'some-sections-are-empty': 'One or more sections are empty. You must assign content to each section in order to save.',
                'name-label': 'Name',
                'description-label': 'Description',
                'section-content': 'Section content',
                'layout': 'Layout',
                'theme': 'Theme',
                'default': 'Black',
                'black': 'Black',
                'white': 'White',
                'blue': 'Blue',
                'cactus': 'Cactus'
            }
        },
        'devices': {
            states: {
                state: 'State:',
                Unknown: 'Unknown',
                Initializing: 'Initializing',
                WaitingForPresentation: 'Waiting for presentation',
                LoadingPresentation: 'Loading presentation',
                Unreachable: 'Unreachable',
                Presenting: 'Presenting',
                Shutdown: 'Shutdown'
            },
            link: {
                'no-device-info-box': {
                    title: 'How to I get my PIN?',
                    content: 'To get your pin, power your device and connect it to a screen. A series of instructions will be displayed. Follow them until your device displays its linking pin.'
                },
                'title': 'Link your device',
                'link-success': 'The device was successfully linked to your account.',
                'naming-success': 'The device was successfully named.',
                'enter-your-pin': 'Type the four digits pin displayed on your device\'s screen.',
                'name-your-device': 'Name your device',
                'step-1': 'Link',
                'step-2': 'Name',
                'step-3': {
                    title: 'Done!',
                    content: 'You\'re all set! Click one of the buttons below to either edit your device or access your devices list.'
                },
                'unnamed-device': 'Unnamed device'
            },
            list: {
                'title': 'Devices list',
                'from-group': 'from group:',
                'your-devices': 'Your devices',
                'configure-group': 'Edit group',
                'failed-to-retrieve-list': 'An error occured while retrieving your devices.',
                'failed-to-display-list': 'An error occured while trying to display your devices.',
                'link-new-device': 'Link new device',
                'groups-list': 'Devices groups',
                'create-web-view': 'Create web view',
                'jumbotron-empty-device-list': {
                    'title': 'It\'s time to link your device!',
                    'current-page-details': 'You are currently on de device management page. Here, you can view and manage all your devices.',
                    'instructions': 'To link your device, power it, connect any screen and follow the instructions shown. Once the device is displaying the 4 digits pin, press the button below to begin the linking process.',
                    'button': 'Begin linking process'
                }
            },
            edit: {
                'shared-config': {
                    'title': 'Shared Configuration',
                    'description': 'Devices can share a common group. You can then configure the group\'s parameters so that devices from that group share common configurations. Enable shared configuration to assign a group to this device or create a group from this device\'s configurations.',
                    'assign-group-title': 'Assign a group to this device'
                },
                'schedule': {
                    'advance-edit-title': 'Presentation schedule',
                    'table-presentation': 'Presentation',
                    'table-startDate': 'Start',
                    'table-endDate': 'End',
                    'table-action': 'Action',
                    'delete-modal-message': 'Are you sure you want to delete this presentation schedule?',
                    'edit-schedule-title': 'Edit schedule',
                    'edit-schedule-presentation': 'Presentation',
                    'edit-schedule-startDate': 'Starting Date',
                    'edit-schedule-endDate': 'End Date',
                    'edit-schedule-12H24H': '12H / 24H',
                    'date-overlap': 'Start date must be set before end date',
                    'no-schedule': 'You have no scheduled presentation. Press add to setup one.',
                    'schedule-overlap': 'One or many schedule entries overlap.',
                    'unactive-info': 'disabled schedule(s).'
                },
                'open-web-view': 'Open web view',
                'config-mode-title': 'Configuration Type',
                'device-schedule-title': 'Device',
                'shared-schedule-title': 'Group',
                'error-getting-device': 'An error occured while retrieving the device.',
                'title': 'Edit device',
                'not-found': 'Device not found.',
                'name-placeholder': 'Device\'s name',
                'name-is-needed': 'Device name is required.',
                'configure-group': 'Configure group',
                'group-creation-success': 'The group was successfully created.',
                'error-creating-group': 'An error occured while creating the group.',
                'error-refreshing-group': 'An error occured while refreshing the device\'s group.',
                'presentation': 'Presentation',
                'current-presentation-section': 'Current presentation',
                'select-different-presentation': 'Select a different presentation',
                'no-presentation': 'No presentation',
                'error-getting-presentation': 'An error occured while retrieving the device\'s current presentation.',
                'no-presentation-instructions': 'A presentation is required to configure the visual shown on your device\'s screen. To create your first presentation, press the button below.',
                'no-timezone': 'Timezone not configured.',
                'config-timezone-unavailable': 'Your device does not support timezone configuration.',
                'advanced-mode-section': 'Scheduled presentations',
                'activate-advanced-mode': 'Enable scheduled presentations: ',
                'config-timezone-title': 'Device\'s Timezone',
                'config-timezone-subtitle': 'Configure timezone',
                'config-timezone-explanation': 'To ensure the precision of the time at which scheduled presentations will transition, it is important that your device\'s timezone is exact. Please verify that the device found the right timezone, if not configure it.',
                'timezone-placeholder': 'Timezone',
                'timezone-off-note': '*Note: If you deactivate the manual timezone configuration, your device will override its timezone with a value obtained using a geolocalization system.',
                'unlink': 'Unlink device',
                'unlink-confirm': 'Are you sure you want to unlink the device from this administrative account?',
                'unlink-success': 'The device has been unlinked',
                'unlink-error': 'Failed to unlink device',
                'saving-error': 'There was an error while saving your device.',
                'saving-success': 'The new device configuration was successfully saved.',
                'name-label': 'Name',
                'group-conflict-modal': {
                    title: 'Do you wish to remove the device from the group or apply the device\'s settings to its group?',
                    content: 'The device\'s configurations have been modified but are overriden by it\'s group configurations. Please select the desired operation.',
                    secondaryAction: 'Remove device from group',
                    primaryAction: 'Update group settings'
                }
            },
            groups: {
                'group': 'Group:',
                'group-of': 'Group of',
                'create-group': 'Create new group',
                'list': {
                    'title': 'Your devices groups',
                    'failed-to-retrieve-list': 'An error occured while retrieving your devices groups.',
                    'failed-to-display-list': 'An error occured while trying to display your devices groups.',
                    'no-device-in-group': 'There is no device in the selected group.',
                    'jumbotron-empty-list': {
                        'title': 'Create your first devices group',
                        'current-page-details': 'You are currently on the devices group list page. Here, you can view and manage all the devices groups you created.',
                        'instructions': 'A devices group allows you to configure parameters that can be shared by multiple devices.'
                    }
                },
                'edit': {
                    'title': 'Edit devices group',
                    'group-devices-list': 'Group\'s devices list',
                    'delete-success': 'Group has been deleted.',
                    'saving-success': 'The group configuration was successfully saved.',
                    'saving-error': 'An error occured while saving the group.',
                    'error-getting-device': 'An error occured while retrieving the group.',
                    'error-missing-name': 'A name is required to create a group.',
                    'new-default-name': 'Group Name',
                    'delete-modal': {
                        'title': 'Are you sure you want to delete this group?',
                        'content': 'The devices having this group will be dissociated. You can either revert to devices previous configurations or copy group settings.',
                        'override-device-config': 'Override devices with group setting',
                        'keep-device-config': 'Go back to devices setting'
                    }
                }
            }
        },
        'user': {
            'email-action-handler': {
                'verify-email-success': 'Your email was successfully verified. You can now login.',
                'email-recovery-success': 'Your account was successfully recovered.',
                'change-password': 'Change your password.',
                'password-reset-success': 'Your password was successfully changed. You can now login.',
                'password': 'Password'
            },
            'verify-email': {
                'not-verified': 'Please confirm your email address.',
                'not-received': 'If you did not recieve the email, click on the following button to send it again.',
                'success': 'A message containing the instructions to confirm your email address was sent to you.'
            },
            'login': {
                'welcome-to': 'Welcome to',
                'username': 'Username',
                'do-not-have-an-account': 'Do not have an account?',
                'forgot-password': 'Forgot password',
                'password-recovery': 'Password recovery ',
                'password': 'Password'
            },
            'create-account': {
                'create-an-account': 'Create account',
                'already-have-an-account': 'Already have an account?',
                'email': 'Email',
                'first-name': 'First name',
                'last-name': 'Last name',
                'password': 'Password',
                'characters': 'min. 8 characters'
            },
            'forgot-password': {
                'create-an-account': 'Create an account',
                'forgot-password': 'Forgot password',
                'email': 'Email',
                'do-not-have-an-account': 'Do not have an account?',
                'password-recovery': 'Password recovery',
                'success': 'An email containing the instructions to reinitialize your password was sent to your email address.'
            }
        },
        'home': {
            dashboard: {
                'welcome-to-prism-board': 'Welcome to your dashboard.',
                'jumbotron-guide-welcome': {
                    'current-page-details': 'Don\'t worry, we will guide you through your device\'s configuration. You are currently on the home page. Once the initial configuration is over, you will be able to see a list of your devices on this page.',
                    'instructions': 'Complete the tasks below to configure your device.'
                },
                'task-no-presentation': {
                    'title': 'Create a presentation',
                    'task-details': 'A presentation is needed to configure the visual elements displayed on your device\'s screen while in presentation mode.'
                },
                'task-no-device': {
                    'task-details': 'You must link your device to this administrative account to be able to configure it.'
                },
                'devices-dashboard': {
                    'linked-devices': 'Linked Devices',
                    'name': 'Name',
                    'group': 'Group',
                    'state': 'Status',
                    'current-pres': 'Current presentation',
                    'next-pres': 'Next presentation',
                    'next-start': 'Time before transition'
                }
            }
        },
        'account': {
            edit: {
                'title': 'My account',
                'edit-account': 'Edit account',
                'first-name': 'First name',
                'last-name': 'Last name',
                'email': 'Email',
                'success': 'Your account was sucessfully updated.',
                'account-details': 'Account details'
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/shared/i18n/en-CA.ts